import ZaiaModal from "./ZaiaModal";

export default ZaiaModal;